<template>

  <BasicLayout>
    <v-toolbar flat="flat">
      <v-toolbar-title>Matches this week</v-toolbar-title>
    </v-toolbar>
    <div v-if="sportsToggled.length === 0">
      <div class="sport-buttons" v-for="sport in sports" :key="sport.id" @click="toggleSport(sport)">{{ sport.name }}</div>
    </div>
    <div class="elevation-4" v-if="sportsToggled.length !== 0">
      <v-data-table :headers="columns" :items="matchCounts" :rows-per-page-items="[-1]" :hide-actions="true" :loading="false">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.day }}</td>
          <td v-for="(sport, index) of sportsToggled" :key="index">{{ printValue(props.item.count[index]) }}</td>
        </template>
      </v-data-table>
    </div>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import Vue from 'vue'

export default {
  name: 'MatchesThisWeek',
  components: {
    BasicLayout
  },
  data: () => ({
    sportsToggled: [],
    columns: [{
      text: 'Day',
      sortable: false
    }],
    matchCounts: [],
    sports: [],
    loading: 0
  }),
  methods: {
    getMonday () {
      const d = new Date()
      let day = d.getDay()
      let diff = d.getDate() - day + (day === 0 ? -6 : 1) // adjust when day is sunday
      return new Date(d.setDate(diff))
    },

    printValue (v) {
      return v === -1 ? '' : v.toString()
    },
    toggleSport (sport) {
      this.sportsToggled.push(sport)
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      let date = this.getMonday()
      let tommorow = this.getMonday()
      tommorow.setDate(date.getDate() + 1)

      for (const d in days) {
        let date_ = new Date(date.getTime() + d * 24 * 60 * 60 * 1000)
        const day = date_.getDate()
        const month = date_.getMonth() + 1

        this.matchCounts.push({
          day: day + '/' + month + ' ' + days[d],
          count: []
        })
      }
      this.columns.push({
        text: sport.name,
        sortable: false
      })
      for (const day of days) {
        const dayIndex = days.indexOf(day)
        const row = this.matchCounts[dayIndex]

        for (const sport of this.sportsToggled) {
          const index = row.count.length

          row.count.push(-1)
          this.loading++
          date.setHours(0)
          tommorow.setHours(0)
          this.$store.dispatch('fetchMatches', {
            sportID: sport.id,
            startDate: date.toISOString(),
            endDate: tommorow.toISOString(),
            pageSize: 1,
            withTotalItems: true
          })
            .then(matches => {
              Vue.set(row.count, index, matches.totalItems)
            })
            .catch(err => {
              console.error(err)
            })
        }
        date.setDate(date.getDate() + 1)
        tommorow.setDate(tommorow.getDate() + 1)
      }
    }
  },
  mounted () {
    this.loading++
    this.$store.dispatch('getSports')
      .then(sports => {
        for (const sport of sports) {
          this.sports.push({
            id: sport.id,
            name: sport.labels.default
          })
        }
        this.loading--
      })
      .catch(err => {
        console.error('Failed to get sports: ', err)
        this.loading--
      })
  }
}

</script>

<style lang="scss" scoped>

  @import "../styles/main-colors";

  .container {
    background-color: $background-dark;
  }

  .sport-buttons {
    padding: 6px 10px;
    margin: 2px;
    width: fit-content;
    display: inline-block;
    border: 1px solid #888888;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      background-color: #e8e8e8;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/MatchesThisWeek.vue